const isDateTimeInPast = (dateStr, timeStr) => {
    const [hours, minutes, seconds = 0] = timeStr.split(':').map(Number);
    const dateTime = new Date(dateStr);
    dateTime.setHours(hours, minutes, seconds);
    const now = new Date();

    return dateTime < now;
}

export default isDateTimeInPast;